import React from 'react';
import { Shield, Heart, Moon, Eye, Brain, Zap, Activity, ClipboardList, Target, Flame } from 'lucide-react';

export const GlassCard = ({ children, className = '', style = {}, active = false, ...props }) => (
  <div className={`glass-card ${active ? 'glass-card-active' : ''} ${className}`}
    style={{ padding: '24px', ...style }} {...props}>{children}</div>
);

export const BackgroundLayers = () => (
  <>
    <div className="dashboard-stars-1" />
    <div className="dashboard-stars-2" />
    <div className="dashboard-stars-highlight" />
    <div className="dashboard-ambient-glow" />
  </>
);

export const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(14,24,52,0.98), rgba(11,20,44,0.98))',
      backdropFilter: 'blur(16px)', border: '1px solid rgba(56,189,248,0.15)',
      borderRadius: '12px', padding: '10px 14px',
      boxShadow: '0 8px 30px rgba(0,0,0,0.4), 0 0 15px rgba(56,189,248,0.08)',
    }}>
      <p className="text-xs mb-1" style={{ color: '#94A3B8' }}>{label}</p>
      {payload.map((p, i) => <p key={i} className="text-sm font-bold" style={{ color: p.color }}>{p.name}: {p.value}</p>)}
    </div>
  );
};

export const getModuleIcon = (domain) => {
  const map = { kaygi: Shield, ruh_hali: Heart, uyku: Moon, dikkat: Eye, hafiza: Brain, enerji: Zap, bedensel: Activity, gunluk_islev: ClipboardList, bilissel: Brain, kalp_dolasim: Heart };
  return map[domain] || Target;
};

export const getCatIcon = (cat) => {
  const map = { anxiety: Shield, mood: Heart, sleep: Moon, stress: Zap, energy: Flame, routine: Target, cognitive: Brain, cardiovascular: Heart };
  return map[cat] || Target;
};
